import React from "react";
import { Home } from "./pages";

export default function App() {
  return <Home />;
}
